<template>
  <v-card>
    <v-container>
      <v-row justify="center">
        <v-img class="ma-2" max-width="300" src="/livesync_logo.png" />
      </v-row>
      <span class="font-weight-bold ml-4">Change Password</span>
      <v-progress-linear
        class="mt-0"
        :active="progress"
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
      <v-card-text>
        <div class="mt-4 mb-6">
        <span>Please check your email. We have sent
          <br>a verification code to the given email address.</span>
        </div>
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="username"
            :rules="emailRules"
            type="email"
            label="Email"
            required
            autocomplete="username"
            placeholder=" "
            ref="focusedField"
          ></v-text-field>
          <v-text-field
            v-model="code"
            :rules="codeRules"
            type="number"
            label="Verification code"
            required
            autocomplete="new-code"
            placeholder=" "
          ></v-text-field>
          <v-text-field
            :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
            :type="show ? 'text' : 'password'"
            :rules="passwordRules"
            name="input-10-2"
            label="New password"
            v-model="password"
            autocomplete="off"
            class="input-group--focused"
            placeholder=" "
            @click:append="show = !show"
          ></v-text-field>
          <v-text-field
            type="password"
            name="input-10-2"
            label="Confirm password"
            v-model="verifyPassword"
            :rules="verifyPasswordRules"
            autocomplete="off"
            placeholder=" "
            class="input-group--focused"
          ></v-text-field>
          <v-layout row class="bottom">
            <span
              class="return-to-signin"
              @click="back"
            >
              &larr; Back to Sign In page
            </span>
            <v-btn
              class="ml-2"
              color="blue"
              :disabled="!valid"
              light
              @click="changePassword"
              autocomplete="new-password"
            >
              Change password
            </v-btn>
          </v-layout>
        </v-form>
        <div class="auth-error" v-if="error">
          {{ error }}
        </div>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { Auth, Logger } from 'aws-amplify';
import EventBus from '@/utils/EventBus';

const logger = new Logger('ChangePassword');

export default {
  name: 'ChangePasswordView',
  props: {
    mail: {
      type: String,
      required: false,
    },
    click: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      progress: false,
      error: '',
      valid: true,
      show: false,
      emailRules: [
        (v) => !!v || 'Email is required',
        (v) => /.+@.+/.test(v) || 'Email must be valid',
      ],
      code: '',
      codeRules: [
        (v) => !!v || 'Verification code is required',
        (v) => (v && v.length === 6 && /^\d+$/.test(v)) || 'Verification code is 6 digits',
      ],
      password: '',
      passwordRules: [
        (v) => !!v || 'Password is required',
        (v) => (v && v.length >= 8) || 'Minimun length 8 charactes',
        // (v) => (v && /.*[a-z]/.test(v)) || 'Must contain at least one lower case letter',
        // (v) => (v && /.*[A-Z]/.test(v)) || 'Must contain at least one upper case letter',
        // (v) => (v && /.*[0-9]/.test(v)) || 'Must contain at least one digit',
        // eslint-disable-next-line
        // (v) => (v && /.*[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`]/.test(v)) || 'Must contain at least one special character: ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \\ , > < \' : ; | _ ~',
      ],
      verifyPassword: '',
      verifyPasswordRules: [
        (v) => (v && v === this.password) || '',
      ],
    };
  },
  mounted() {
    setTimeout(this.focusOnField, 1000);
  },
  components: {
  },
  computed: {
    username: {
      get() {
        return this.mail;
      },
      set(newval) {
        this.$emit('update:mail', newval);
      },
    },
  },
  methods: {
    changePassword() {
      // Start progress indicator
      this.progress = true;

      Auth.forgotPasswordSubmit(this.username, this.code, this.password)
        .then(() => {
          EventBus.$emit('authState', 'LOG_IN');
        })
        .catch((err) => {
          this.setError(err);
        })
        .finally(() => {
          this.progress = false;
        });
    },
    back() {
      EventBus.$emit('authState', 'LOG_IN');
    },
    setError(e) {
      this.error = e.message || e;
      logger.error(this.error);
    },
    focusOnField() {
      this.$refs.focusedField.focus();
    },
  },
};
</script>

<style scoped>
.auth-error {
  margin: 5px;
  padding: 3px;
  color: #E91300;
}
.bottom {
  justify-content: space-between;
  align-items: center;
}
.return-to-signin:hover {
  text-decoration: underline;
  cursor: pointer;
  color: #e66465;
}
</style>
